// extracted by mini-css-extract-plugin
export default {"root":"NoResults_root__PJWBl","icon":"NoResults_icon__F14g-","message":"NoResults_message__eYBSr"};